module.exports = __webpack_public_path__ + "img/arrow-down-icon-light.f3889552.svg";